import axios from '@atheneum/api'
import { formatDateTime, getDate } from '@root/../../packages/platform-api/dist/lib'
import { extendObservable } from 'mobx'

class ZoomRecordingStore {
  constructor() {
    extendObservable(this, {
      loading: true,
      recordings: null,
      epl: null,
      error: null,
      recordingTypes: {
        VIDEO: 'video/mp4',
        AUDIO: 'audio/mp4' //zoom audio files have M4A extension, but that might not work properly.
      },
      selectedGroup: 0,
    })
  }

  fetchRecordingAndStreamingURL(eplHash, requestedRecordingId) {
    axios.get(`/api/recording/${eplHash}`).then((response) => {
      const { epl, recordings } = response.data
      this.epl = epl
      this.recordings = recordings
      this.loading = false

      if (requestedRecordingId) {
        const requestedRecordingGroupIndex = recordings.findIndex((group) => {
          return group.find((recording) => recording.recordingId === requestedRecordingId)
        })

        //Preselect group and video/audio based on URL we landed on
        this.setSelectedGroup(requestedRecordingGroupIndex)
      }
    }).catch((error) => {
      this.loading = false
      this.error = error
    })
  }

  getRecordingGroupInterviewDateTime(group) {
    return formatDateTime(getDate(group[0].recordingStart), false)
  }

  setSelectedGroup(groupIndex) {
    this.selectedGroup = groupIndex
  }
}

export default ZoomRecordingStore
